var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0393 11.4442C11.3536 11.549 11.6934 11.3791 11.7982 11.0647C11.903 10.7504 11.7331 10.4106 11.4187 10.3058L11.0393 11.4442ZM8.4165 9.9375H7.8165C7.8165 10.1958 7.98176 10.425 8.22677 10.5067L8.4165 9.9375ZM9.0165 6.01739C9.0165 5.68602 8.74787 5.41739 8.4165 5.41739C8.08513 5.41739 7.8165 5.68602 7.8165 6.01739H9.0165ZM11.4187 10.3058L8.60624 9.36829L8.22677 10.5067L11.0393 11.4442L11.4187 10.3058ZM9.0165 9.9375V6.01739H7.8165V9.9375H9.0165ZM15.3165 9C15.3165 12.8108 12.2273 15.9 8.4165 15.9V17.1C12.89 17.1 16.5165 13.4735 16.5165 9H15.3165ZM8.4165 15.9C4.60574 15.9 1.5165 12.8108 1.5165 9H0.316504C0.316504 13.4735 3.943 17.1 8.4165 17.1V15.9ZM1.5165 9C1.5165 5.18923 4.60574 2.1 8.4165 2.1V0.9C3.943 0.9 0.316504 4.52649 0.316504 9H1.5165ZM8.4165 2.1C12.2273 2.1 15.3165 5.18923 15.3165 9H16.5165C16.5165 4.52649 12.89 0.9 8.4165 0.9V2.1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b186e2bd54086c6cd8235f4cf8b2ad8b.svg";
export { ForwardRef as ReactComponent };